var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoShipmentHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_944_6125)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 40,
    r: 32,
    fill: "#808FA1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 40,
    r: 31.4,
    stroke: "white",
    strokeWidth: 1.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4398 26.3091C45.2048 24.0999 42.2247 22.8364 39.1256 22.8153C36.0264 22.7943 33.0991 23.9811 30.9596 26.1972C28.8193 28.3766 27.6792 31.2942 27.7462 34.4029C27.885 40.8396 33.2116 46.1048 39.6287 46.1484C42.7278 46.1695 45.6551 44.9826 47.7947 42.7666C49.935 40.5871 51.0751 37.6695 51.0081 34.5609C50.941 31.4522 49.6747 28.5183 47.4398 26.3091Z",
    fill: "#808FA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6451 46.9165C32.827 46.8702 27.1643 41.237 27.0168 34.398C26.9459 31.1065 28.155 28.0065 30.438 25.6817C32.721 23.357 35.7917 22.0614 39.1097 22.084C42.4276 22.1065 45.5543 23.4076 47.9383 25.764C50.3222 28.1205 51.7018 31.2381 51.7736 34.5661C51.8446 37.8577 50.6355 40.9576 48.3525 43.2824C46.0338 45.6435 42.963 46.939 39.6451 46.9165L39.6293 46.1851L39.6136 45.4536C42.5304 45.4734 45.2405 44.3583 47.2738 42.2878C49.2707 40.217 50.3418 37.4818 50.2795 34.5926C50.2164 31.6668 49.027 28.9162 46.9038 26.8175C44.7806 24.7187 42.0216 23.5664 39.1412 23.5468C36.2244 23.527 33.5143 24.6422 31.4809 26.7127C29.4841 28.7834 28.413 31.5187 28.4753 34.4079C28.6054 40.4423 33.5968 45.3762 39.6128 45.417L39.6451 46.9165Z",
    fill: "#282D33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0286 41.0777C44.3176 42.8259 42.0447 43.8017 39.5694 43.7873C34.5096 43.7579 30.2743 39.5942 30.1684 34.4655C30.1177 32.0111 31.0158 29.672 32.7275 27.9604C34.4385 26.2122 36.7121 25.2731 39.1867 25.2508C41.6256 25.265 43.9749 26.231 45.7585 27.9996C47.5421 29.7682 48.5362 32.0816 48.5876 34.5726C48.6383 37.0271 47.7395 39.3295 46.0286 41.0777Z",
    fill: "#CFD5DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1382 34.4202L31.6797 34.4103C31.6347 32.3256 32.3951 30.3926 33.822 28.9396C35.249 27.4866 37.1998 26.6588 39.2416 26.6726L39.2732 28.1356C37.5959 28.1242 36.0058 28.7716 34.8651 29.9706C33.7243 31.1696 33.1027 32.7744 33.1382 34.4202Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9631 42.8932L47.7544 47.2666L57.332 56.9197L61.5407 52.5463L51.9631 42.8932Z",
    fill: "#FABE00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0004 46.7276L53.0127 47.7539L58.317 53.0998L59.3047 52.0735L54.0004 46.7276Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4832 43.4327L48.2339 46.8037L49.9167 48.4972L53.166 45.1262L51.4832 43.4327Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9249 49.4998L47.2123 46.8101L51.4898 42.4395L54.2023 45.1292L49.9249 49.4998ZM49.2501 46.7853L49.8818 47.4117L52.1631 45.0807L51.5314 44.4543L49.2501 46.7853Z",
    fill: "#282D33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8881 53.8935C61.9267 55.7618 60.4652 57.2551 58.6087 57.2443C58.3486 56.9864 58.0514 56.6917 57.7913 56.4337C58.8963 55.3047 59.9656 54.212 61.0706 53.083C61.3307 53.3409 61.5908 53.5988 61.8881 53.8935Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2989 57.9747L56.7382 56.4272L61.0157 52.0567L62.5763 53.6042L62.5823 53.8972C62.6292 56.1685 60.847 57.9896 58.5901 57.9764L58.2989 57.9747ZM58.8131 56.4393L58.8874 56.513C60.1221 56.3737 61.0488 55.4267 61.1687 54.182L61.0944 54.1083L58.8131 56.4393Z",
    fill: "#282D33"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2006 44.128L47.207 45.1572L48.6482 46.6057L49.6417 45.5764L48.2006 44.128Z",
    fill: "#282D33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9431 41.4265L47.9512 42.4541L49.8084 44.3218L50.8004 43.2942L48.9431 41.4265Z",
    fill: "#282D33"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_944_6125",
    x: 0.5,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.760784 0 0 0 0 0.819608 0 0 0 0 0.85098 0 0 0 0.46 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_944_6125"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_944_6125",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoShipmentHistory);
export default __webpack_public_path__ + "static/media/noShipmentHistory.92244045ffda6513585e9e66b8dc15d6.svg";
export { ForwardRef as ReactComponent };